<template>
  <div class="fullscreen" ref="preview">
    <div class="container" v-if="showCodeStatus">
      <div class="codebox">
        <h1 class="title">请输入提取密码</h1>
        <div class="codebody">
          <div class="form-group">
            <input
              class="form-control"
              type="password"
              v-model.trim="code"
              readonly
              onfocus="this.removeAttribute('readonly');"
              name="code"
              data-vv-as="密码 "
              v-validate="{ required: true }"
            />
            <button class="btn btn-primary" type="button" @click="getPassword">
              提取文件
            </button>
          </div>
          <span class="help-block" v-show="errors.has('code')">{{
            errors.first("code")
          }}</span>
        </div>
      </div>
    </div>
    <component :is="previewer" v-if="showLinkInfoStatus"></component>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { getPreviewTypeByFileExt } from "@/utils/icon";
import { linkTargetConstraint, linkTargetPreview } from "@/api/share/share";
export default {
  name: "Linked",
  components: {},
  data() {
    return {
      previewer: "unknowPreview",
      errMsg: "",
      code: "",
      showLinkInfoStatus: false, // 是否显示发布详情（预览页）
      category: null,
      preview_path: null, // 预览地址
      expiredStatus: false, // 是否过期
      showCodeStatus: false, // 是否显示密码弹框
      constraint: {
        password: "",
      },
    };
  },
  created() {
    /**
     * 1、从url中获取link_number和link_resources_list参数
     * 2、获取发布具有的策略并获取需要的策略
     *  (1)获取password策略
     */
    this.link_number = this.$route.params.link_number;
    this.resource_number = this.$route.params.resource_number;
    this.getLinkTargetConstraint();
  },
  methods: {
    // 获取发布具有的策略
    getLinkTargetConstraint() {
      linkTargetConstraint(this.link_number)
        .then((res) => {
          if (res.status_code === 200) {
            // 检测password策略，如果有，则获取password
            if (res.entity.is_password) {
              if (Cookies.get(this.link_number)) {
                this.init();
              } else {
                this.showCodeStatus = true;
              }
            } else {
              this.getLinkTargetPreview();
            }
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 存储&验证password
    getPassword() {
      this.$validator.validate("code").then((valid) => {
        if (valid) {
          Cookies.set(this.link_number, this.code);
          this.getLinkTargetPreview();
        }
      });
    },
    // 有密码时，进入页面初始化请求，不显示错误信息
    init() {
      linkTargetPreview({
        link_number: this.link_number,
        link_constraint: {
          password: Cookies.get(this.link_number),
        },
        link_resource_number: this.resource_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.showCodeStatus = false;
            this.showLinkInfoStatus = true;
            this.previewer =
              getPreviewTypeByFileExt(res.entity.file_ext) + "Preview";
            let preview_path = res.entity.preview_path;
            if (
              res.entity.category === "video" &&
              res.entity.trans_path &&
              !res.entity.is_preview
            ) {
              preview_path = res.entity.trans_path;
              this.previewer = "mp4Preview";
            }
            this.$store.commit("setPreviewData", {
              file_ext: res.entity.file_ext,
              position: "fullscreen",
              preview_path: preview_path,
              previewer: this.previewer,
            });
          } else if (res.status_code === 439) {
            // 分享访问时间已过期
            this.showCodeStatus = false;
            this.showLinkInfoStatus = true;
            this.$store.commit("setPreviewData", {
              file_ext: "",
              position: "fullscreen",
              preview_path: "",
              previewer: "unknowPreview",
              message: res.message,
            });
          } else if (res.status_code === 434) {
            // 密码错误
            this.showCodeStatus = true;
            this.showLinkInfoStatus = false;
          } else {
            this.showCodeStatus = false;
            this.showLinkInfoStatus = true;
            this.$store.commit("setPreviewData", {
              file_ext: "",
              position: "fullscreen",
              preview_path: "",
              previewer: "unknowPreview",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.errMsg = err;
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 获取发布的资源链接地址
    getLinkTargetPreview() {
      linkTargetPreview({
        link_number: this.link_number,
        link_constraint: {
          password: Cookies.get(this.link_number),
        },
        link_resource_number: this.resource_number,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.showCodeStatus = false;
            this.showLinkInfoStatus = true;
            this.previewer =
              getPreviewTypeByFileExt(res.entity.file_ext) + "Preview";
            let preview_path = res.entity.preview_path;
            if (
              res.entity.category === "video" &&
              res.entity.trans_path &&
              !res.entity.is_preview
            ) {
              preview_path = res.entity.trans_path;
              this.previewer = "mp4Preview";
            }
            this.$store.commit("setPreviewData", {
              file_ext: res.entity.file_ext,
              position: "fullscreen",
              preview_path: preview_path,
              previewer: this.previewer,
            });
          } else if (res.status_code === 439) {
            // 分享访问时间已过期
            this.showCodeStatus = false;
            this.showLinkInfoStatus = true;
            this.$store.commit("setPreviewData", {
              file_ext: "",
              position: "fullscreen",
              preview_path: "",
              previewer: "unknowPreview",
              message: res.message,
            });
          } else if (res.status_code === 434) {
            // 密码错误
            this.showCodeStatus = true;
            this.showLinkInfoStatus = false;
            this.errors.add({
              field: "code",
              msg: res.message,
            });
          } else {
            this.showCodeStatus = false;
            this.showLinkInfoStatus = true;
            this.$store.commit("setPreviewData", {
              file_ext: "",
              position: "fullscreen",
              preview_path: "",
              previewer: "unknowPreview",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.errMsg = err;
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    resizeLinked() {
      this.$refs.preview.style.height = window.innerHeight + "px";
    },
  },
  mounted() {
    this.$refs.preview.style.height = window.innerHeight + "px";
    window.addEventListener("resize", this.resizeLinked);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeLinked);
  },
};
</script>

<style scoped>
.fullscreen {
  width: 100%;
  height: 100%;
  /* min-height: 60px; */
  overflow: hidden;
}
</style>